import { RouteContext } from '@common/contexts';
import { useContext } from 'react';
import { matchRoutes, RouteMatch, useLocation } from 'react-router-dom';

export const useCurrentMatchRoutes = (): RouteMatch[] => {
    const location = useLocation();
    const appRoutes = useContext(RouteContext.get());
    return matchRoutes(appRoutes, location.pathname) ?? [];
}
